import React from 'react';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-114">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full -z-10 overflow-hidden" data-id="element-115">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-blue-100/50 rounded-full blur-3xl opacity-60" data-id="element-116" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-indigo-50/50 rounded-full blur-3xl opacity-60" data-id="element-117" />
      </div>

      <div className="container mx-auto px-4 md:px-6" data-id="element-118">
        <div className="max-w-4xl mx-auto text-center" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-120">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 border border-blue-100 text-blue-700 text-sm font-medium mb-6" data-id="element-121">
              <span className="relative flex h-2 w-2" data-id="element-122">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" data-id="element-123"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500" data-id="element-124"></span>
              </span>
              Nou: Parteneriate cu 12 bănci de top
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-6 leading-[1.1]" data-id="element-125">
              Obține cel mai bun credit pentru{' '}
              <span className="text-blue-600" data-id="element-126">compania ta</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-127">
              Comparăm ofertele băncilor pentru tine în timp real.
              <br className="hidden md:block" data-id="element-128" />
              Gratuit. Transparent. Fără birocrație inutilă.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-129">
              <Button size="lg" className="w-full sm:w-auto text-lg h-14 px-8 shadow-blue-200/50 shadow-lg hover:shadow-blue-200/80 hover:-translate-y-0.5 transition-all" data-id="element-130">
                Începe Pre-calificarea
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-131" />
              </Button>
              <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg h-14 px-8" data-id="element-132">
                Vezi cum funcționează
              </Button>
            </div>

            <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-slate-500 font-medium" data-id="element-133">
              <div className="flex items-center gap-2" data-id="element-134">
                <CheckCircle2 className="h-4 w-4 text-emerald-500" data-id="element-135" />
                <span data-id="element-136">Răspuns în 24h</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-137">
                <CheckCircle2 className="h-4 w-4 text-emerald-500" data-id="element-138" />
                <span data-id="element-139">100% Online</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-140">
                <CheckCircle2 className="h-4 w-4 text-emerald-500" data-id="element-141" />
                <span data-id="element-142">Fără costuri ascunse</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}